<script>
  import { createEventDispatcher, onDestroy } from 'svelte';
  import { fade } from 'svelte/transition';
  import { Button } from '@sveltestrap/sveltestrap';

  import { classnames } from '@client/utils/classnames';

  import { getBannersContext } from './banner.context';

  /**
   * Additional CSS class name for the component
   * @type {string}
   * @default ''
   */
  let className = '';
  export { className as class };

  export let banner = {};

  const dispatch = createEventDispatcher();

  const { removeBanner } = getBannersContext();

  const { id, color, autohide, header, text, component, dismissable = true, type = 'default' } = banner;

  const onRemove = () => removeBanner(id);

  let timeout = null;

  if (autohide) {
    timeout = setTimeout(onRemove, autohide);
  }

  const icons = {
    success: 'os-icon-check',
    error: 'os-icon-x',
    warning: 'os-icon-alert-triangle',
    info: 'os-icon-info'
  };

  onDestroy(() => {
    if (autohide && timeout) {
      clearTimeout(timeout);
    }
    onRemove();
  });
</script>

{#if component}
  <svelte:component this={component} {banner} {onRemove} />
{:else}
  <div
    class={classnames('banner', type, className)}
    style="--notification-bg-color: {color};"
    class:compact={!header}
    role="status"
    aria-live="polite"
    in:fade
    out:fade
  >
    {#if header || $$slots.header}
      <div class="header">
        <slot name="header">
          <span>{@html header}</span>
        </slot>

        {#if dismissable}
          <Button
            class="ms-auto"
            close
            on:click={() => {
              dispatch('dismiss');
              onRemove();
            }}
            aria-label="delete banner"
          />
        {/if}
      </div>
    {/if}
    <div class="body">
      {#if !header && type && icons[type]}
        <i class={icons[type]} />
      {/if}

      <slot>
        <span>{@html text}</span>
      </slot>

      {#if !autohide && !header && dismissable}
        <Button
          class="ms-auto"
          close
          on:click={() => {
            dispatch('dismiss');
            onRemove();
          }}
          aria-label="delete banner"
        />
      {/if}
    </div>
  </div>
{/if}

<style lang="scss" src="./banner.scss"></style>
